export const modalTableConfig = {
  title: '素材回复详情',
  propList: [
    {
      prop: 'corpName',
      label: '企业主体',
      minWidth: '120'
    },
    { prop: 'sid', label: '账户ID', minWidth: '80', sortable: true },
    {
      prop: 'sname',
      label: '名称',
      minWidth: '120'
    },
    {
      prop: 'sendTime',
      label: '发送时间',
      minWidth: '120',
      sortable: true
    },
    {
      prop: 'uname',
      label: '客户名称',
      minWidth: '120'
    },
    {
      prop: 'replyTime',
      label: '回复时间',
      minWidth: '120',
      sortable: true
    },
    {
      prop: 'content',
      label: '回复内容',
      minWidth: '120'
    }
  ],
  showIndexColumn: false,
  showSelectColumn: false
}
